
import { useEffect, useState } from "react";
import 'antd-button-color/dist/css/style.css';
import { useAuthentication } from "../provider/Auth";
import { useNavigate } from "react-router-dom";
import { Card, Flex, FloatButton, Select, Segmented, Popover, notification, List ,Table} from 'antd';
import Button from "antd-button-color";
import { UserOutlined, SettingOutlined, LogoutOutlined, AudioOutlined, AudioMutedOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { MetaHumanComponent, useMetaHuman } from './MetaHumanComponent';
import { useSpeechToText } from './SpeechToTextComponent';
import { useWS } from '../provider/WS';
import { IMETAMessageType } from '../config/imetahuman';
import { IActors, getActorMap } from "../config/iactors";
import { IAttributes } from "../config/iattributes";
import { IDisplayMode } from "../config/displayMode";
import { IFields, IFieldsPos } from "../config/iFieldsLabels";
import { Auth  } from "aws-amplify";
import some from 'lodash/some';



const { v4: uuidv4 } = require('uuid');




export const Console = ({ hidden, ...props }) => {

    const navigate = useNavigate();
    const { check ,getConfig } = useAuthentication();
    const { message, lastJsonMessage } = useWS();
    const { actor, background,voice, initialize, isTalking, isInitialized, toUE, addResponseEventListener ,addStreamingDataListeners, smallVideoBox} = useMetaHuman();
    const { startCaptioning, startStopListening, blockListening, translation } = useSpeechToText();
    const [hideDisclaimer, setHideDisclaimer] = useState(false);
    const [micIcon, setMicIcon] = useState('')
    const [microphone, setMicrophone] = useState(true);
    const [selectedActor, setSelectedActor] = useState();
    const [tenats , setTenats] = useState(null);
    const [currentTenant, setCurrentTenant] = useState('plain');
    const [selecTNOptions, setSelecTNOptions] = useState();
    const [hideTenantSelect,setHideTenantSelect] = useState(false);
    const [streamingData , setStreamingData] = useState(null);
    const [streamingInfoClass, setstreamingInfoClass] = useState("");
    const [viewNotification , setViewNotification] = useState(true);
    const [displayMode , setDisplayMode] = useState(IDisplayMode.Full);
    const [displayInfoCard,setDisplayInfoCard] = useState(false);
    const [displayPushToTalk, setDisplayPushToTalk] = useState(false);
    const [enabledNeedName , setEnabledNeedName] = useState(false);
    const [actorName, setActorName] = useState('');

    const [tableDataSource, setTableDataSource] = useState([]);
    const [tableColumns , setTableColumns] = useState([]);

    const [api, contextHolder] = notification.useNotification();
    const [ config , setConfig] = useState({});
    const [ currentBGImage, setCurrentBGImage] = useState('');

    useEffect(() => {

        /********************************************
         *  change layout
         ********************************************/    
        if (displayMode == IDisplayMode.Full) {
            try {
                smallVideoBox(false);
            } catch(e) {
                console.log("the video hasn't started yet");
            }
            setDisplayInfoCard(false);
        }

        if (displayMode == IDisplayMode.Table) {
            try {
                smallVideoBox(true);
            } catch(e) {
                console.log("the video hasn't started yet");
            }
            setDisplayInfoCard(true);
        }
       
    },[ displayMode]);



    useEffect(() => {

        /********************************************
         *  adding the player to the page
         ********************************************/

        const script = document.createElement('script');
        script.src = '/webRtcPlayer.js'; // Assicurati di specificare il percorso corretto
        script.async = true;
        document.head.appendChild(script);

        check().then(user => {
            setConfig(user);
            if (user) {

                if (user.isDisabled === true ) {
                    navigate('/disabled');
                }


                message({
                    type: IMETAMessageType.TNList,
                    model: currentTenant,
                    message: '',
                    uid: uuidv4(),
                    user: user.user
                });

                if (user.hideSpeechToTextInfo === true) {
                    setViewNotification(false);
                }

                if (user.hideStreamingInfo === true) {
                    setstreamingInfoClass('hidder');
                }

                if (user.pushToTalk === true) {
                    setDisplayPushToTalk(true);
                }

                if (user.actorName != '') {
                    setEnabledNeedName(true);
                    setActorName(user.actorName);
                }
                

            } else {
                navigate("/");
            }
        });

    }, []);


    /********************************************
     *  Check when the stream was initialized
     ********************************************/

    useEffect(() => {

        if (isInitialized === true) {
            if (config.backgroundImageUrl != '') {
                background(config.backgroundImageUrl);
            } else if (currentBGImage != '') {
                background(currentBGImage);
            }
            if (config.actor !== undefined && isNumeric(config.actor)) {
                actor(config.actor);
                setSelectedActor(config.actor);
            }

            if(config.pushToTalk === true) {
                setDisplayPushToTalk(true);
            }

        }
    }, [isInitialized]);


    /*******************************
     *  TextToSpeech to AI Backend
     *******************************/

    useEffect(() => {


        let check = checkIfSendMessageToBackEnd(translation)
        console.log("CHECK IF SEND SPEECH MESSAGE",check);
        if (check === true) {
            setDisplayMode(IDisplayMode.Full);
            if (viewNotification === true) { 
                openNotification(translation);
            }   
            
            message({
                type: IMETAMessageType.AIRequest,
                model: currentTenant,
                message: translation,
                uid: uuidv4(),
                user: config.user
            });           


        }

    }, [translation]);

    /*******************************
     *  FROM UE TO WEb
     *******************************/

    useEffect(() => {
        if (isTalking === false && config.pushToTalk === false) {

            enableDisableMicrophone(true);
        }
    }, [isTalking]);



    /*******************************
     *  FROM Backend to Frontend
     *******************************/

    useEffect(() => {
       
        console.log('FROM BK to FE', lastJsonMessage);
        if (lastJsonMessage != null) {
            if (lastJsonMessage.type === IMETAMessageType.UESpeak) {
                let message = { type: IMETAMessageType.UESpeak, message: lastJsonMessage.message, animation: lastJsonMessage.animation };

                if ("other" in lastJsonMessage) {
                    setDisplayMode(IDisplayMode.Table);
                    let i = 0;
                    let columns = [];
                    let dataSource = [];
                    lastJsonMessage.other.forEach(element => {
                        console.log(element);
                        if (i === 0) {
                            Object.keys(element).forEach(key => {

                                columns.push( {
                                    title: IFields[key],
                                    dataIndex: key,
                                    key: IFieldsPos[key],
                                    render: (value) => {

                                        if (typeof value === "number") {
                                            const chatWorlds = ['deposit','rental_amount'];

                                            const containsElement = some(chatWorlds, element => key.includes(element));

                                            if (containsElement) {
                                                return "€ "  + value.toLocaleString("it-IT");
                                            } else {
                                                return value.toLocaleString("it-IT");
                                            }
                                        } else {
                                            if (value != null && value.startsWith("http")) {
                                                return <img src={`${value}`} style={{ width:"120px"}}    onError={event => {
                                                    event.target.src = "https://pictures.dealer.com/g/ganleychevroletofauroraoh/0430/a976281f56ff06d46dc390283aa14da6x.jpg"
                                                    event.onerror = null
                                                  }} />;
                                            } else {
                                                return value.charAt(0).toUpperCase() + value.slice(1);
                                            }
                                        }

                                       
                                      }
                                  });

                            })

                            columns.sort((firstItem,secondItem)=> firstItem.key - secondItem.key);

                            setTableColumns(columns);
                        }

                        element.key = i;
                        dataSource.push(element);

                        i++;
                    });

                    setTableDataSource(dataSource);

                }
                enableDisableMicrophone(false);
                toUE(message);
            }
            if (lastJsonMessage.type === IMETAMessageType.TNListResponse) {

                setTenats(lastJsonMessage.data);
                let options = [];

                let tenantArray = config.attributes[IAttributes.Tenants].split(',');
                Object.entries(lastJsonMessage.data).forEach(entry => {
                    const [key, value ] = entry;
    
                    if (tenantArray.includes(key)) {
                        let o = { 
                            label : value.label , 
                            value : key,
                            backgroundImageUrl : value.background,
                            voice : value.voice
                        };
                        options.push(o);
                    }
                
                });
                setSelecTNOptions(options);
                if (tenantArray.length == 1) {
                    setCurrentTenant(tenantArray[0]);
                    setHideTenantSelect(true);

                    options.forEach((item) => {
                        if (item.value === tenantArray[0]) {
                            if (item.backgroundImageUrl != '') {
                                background(item.backgroundImageUrl);
                                setCurrentBGImage(item.backgroundImageUrl);
                                voice(item.voice);
                            }
                        }
                   });


                } else {
                    setCurrentTenant(currentTenant);
                    options.forEach((item) => {
                        if (item.value === currentTenant) {
                            if (item.backgroundImageUrl != '') {
                                background(item.backgroundImageUrl);
                                setCurrentBGImage(item.backgroundImageUrl);
                                voice(item.voice);
                            }
                        }
                   });
                }

                
            }


        }
    }, [lastJsonMessage]);



    const checkIfSendMessageToBackEnd = (translation) => {

        let response = false;

        //if (microphone !== false) {
            if (translation != '' && translation != undefined) { 
   
                if (enabledNeedName === true) {
                    const chatWorlds = [ actorName, 'chiami','tuo nome'];
                    const containsElement = some(chatWorlds, element => translation.includes(element));
                    response = containsElement;
                } else {
                    response = true;
                }

               
            } else {
                response = false;
            }
        //}

        console.log('CHECK MESSAGE FUNCTION',response);
        return response;
    }

     /*******************************
     *  Streaming Info
     *******************************/ 

    addStreamingDataListeners("handle_responses",function(data){


        let infoData = [
            {
                title: 'Quality',
                description: data.Quality
            },
            {
                title : 'Duration',
                description: data.Duration
            },  
            {
                title : 'Resolution',
                description: data.Resolution
            },
            {
                title : 'Packet Lost',
                description: data.PacketLost
            },           
            {
                title: ' Bitrate (kbps)',
                description: data.Bitrate
            }, 
            {
                title: 'Frame Rate',
                description: data.Framerate
            }
        ]
        setStreamingData(infoData);
     });




    const isNumeric = (num) => {
        return !isNaN(num)
    }


    const initMetaHuman = () => {
        setHideDisclaimer(true);
        initialize();
        enableDisableMicrophone(!config.micIsDisabled);
    };

    const handleChange = (value) => {

        actor(value);
        setSelectedActor(value);
    };


    const handleChangeTenant = (value) => {
            setCurrentTenant(value);
            selecTNOptions.forEach((item) => {
                if (item.value === value) {
                    if (item.backgroundImageUrl != '') {
                        background(item.backgroundImageUrl);
                        setCurrentBGImage(item.backgroundImageUrl);
                        voice(item.voice);
                    }
                }
           });
    };


    const Logout = async () => {
        await Auth.signOut()
        .then(data => console.log(data))
        .catch(err => console.log(err));
       
    }

    const microphoneClick = () => {
        let mic = !microphone;
        enableDisableMicrophone(mic);
    }



    const enableDisableMicrophone = (status) => {

        setMicrophone(status);
        if (status == true) {
            startCaptioning();
            setMicIcon('recording');
        } else {
            setMicIcon('');
            blockListening();
        }

    }


  const openNotification = (message) => {
    let placement = 'bottomRight';
    api.info({
      message: `Speech detected`,
      description:
      message,
      placement,
    });
  };

    return (
        <>
            <div hidden={hideDisclaimer}>
                <Flex className='Disclaimer' justify='center' align='center'>
                    <Card className='DisclaimerCard'
                        bordered={false}
                        style={{ width: 650 }}
                    >
                        <p>Disclaimer</p>

                        The following service is provided as a web preview and may be subject to changes, updates, or corrections without prior notice. User experience, features, and performance may vary during this preview phase. Users are aware that using the preview service carries potential risks, including system malfunctions, data loss, or other inconveniences. It is recommended that users utilize the preview service for testing and evaluation purposes only and not rely solely on it for critical or productive purposes. Access to the preview service is at the user's discretion.
                        By pressing the "Accept" button, users acknowledge and accept the aforementioned conditions.

                        <br></br><br></br>
                        <Flex justify='center' align='center'>
                            <Button type="primary" onClick={initMetaHuman} >Accept</Button>
                        </Flex>

                    </Card>
                </Flex>
            </div>

            <div  hidden={!hideDisclaimer}>

                <img className='Logo' src="https://www.interlogica.it/wp-content/uploads/2021/10/logo_interlogica_1.svg" />
                <MetaHumanComponent />
                <div hidden={hideTenantSelect} >
                <FloatButton.Group  className="noShadow" shape="square" style={{ right: 280, top: 15 }}  >
                                <Select size="large"
                    value={currentTenant}
                    style={{ width: 200 }}
                    options={ selecTNOptions }
                    onChange={handleChangeTenant}
                    />
                </FloatButton.Group>
                </div>

                <div className='micPushButton' hidden={!displayPushToTalk}>
                <Card className='micPushButtonCard'
                        bordered={false}
                        style={{ height: "150px",width: "150px" }}
                        onMouseDown={() =>  enableDisableMicrophone(true)}
                        onMouseUp={() =>  enableDisableMicrophone(false)}
                    >
                    Push To Talk
                    </Card>
                </div>

                <FloatButton.Group className="noShadow" shape="square" style={{ right: 72, top: 15 }}  >
                    <FloatButton type={micIcon} icon={microphone === true ? <AudioOutlined /> : <AudioMutedOutlined />} onClick={microphoneClick} tooltip={<div>Enable/Disable microphone</div>} />
                </FloatButton.Group>
                
                <FloatButton.Group className="noShadow" shape="square" style={{ right: 24, top: 15 }} trigger="click" icon={<SettingOutlined />} >

                    <Popover
                        placement="left"
                        content={
                            <Segmented
                                onChange={handleChange}
                                value={selectedActor}
                                options={
                                    getActorMap()
                                }
                            />
                        }
                        title="Select Actor"
                        trigger="click"
                    >
                        <FloatButton icon={<UserOutlined />} tooltip={<div>Select an actor</div>}  />
                    </Popover>
                    
                    <Popover
                        placement="left"
                        content={
                            <List
                                itemLayout="horizontal"
                                dataSource={streamingData}
                                renderItem={(item, index) => (
                                <List.Item>
                                    <List.Item.Meta
                                    title={<b>{item.title}</b>}
                                    description={item.description}
                                    />
                                </List.Item>
                                )}
                            />
                        }
                        title="Streaming Info"
                        trigger="click"
                        > 
                    <FloatButton className={streamingInfoClass} icon={<InfoCircleOutlined />} tooltip={<div>Streaming Info</div>} />
        
                    </Popover>
                    

                    <FloatButton icon={<LogoutOutlined />} onClick={Logout} tooltip={<div>Logout</div>} />
                </FloatButton.Group>


                <Flex  vertical className='tableflexBackground' justify='center' align='center'>

                    <Flex vertical className='tableflexCardInside' justify='center' align='center'   style={{ backgroundImage: `url(${currentBGImage})` }}>
                    <Card className='tableflexCard' hidden={!displayInfoCard}
                        bordered={false}
                        style={{ height: "100vh" }}
                    >
                        <br></br>
                        <br></br>
                        <p>Result of the requested search</p>

                        <Table dataSource={tableDataSource} columns={tableColumns}  pagination={false} />
                    </Card>
                    </Flex>
                </Flex>


            </div>
            {contextHolder}
        </>
    );

}